export default "__VITE_ASSET__ClTiNy9T__"